import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appHoverEffectSidebar]',
    standalone: false
})
export class HoverEffectSidebarDirective {
  constructor(private eleRef: ElementRef, private render: Renderer2) {}

  @HostListener('mouseover') onHover() {
    if (window.innerWidth > 768) {
      document.querySelector('.app')?.classList.add('sidenav-toggled1');
    }
  }

  @HostListener('mouseleave') onLeave() {
    if (window.innerWidth > 768) {
      document.querySelector('.app')?.classList.remove('sidenav-toggled1');
    }
  }
}
